angular.module('impactx.orderconfirmation').controller('OCIJumpCtrl', [
    'DeliveryNoteOCIService',
    '$window',
    OCIJumpCtrl
]);

function OCIJumpCtrl(DeliveryNoteOCIService, $window) {
    var jump = DeliveryNoteOCIService.getURL();
    if (jump) {
        $window.location.href = jump;
    }
}